
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"7.145","y":"41.801","width":"24.33","height":"33.71","rx":"7","transform":"rotate(-90 7.145 41.801)","stroke":"#000C1F","stroke-width":"2"}}),_c('path',{attrs:{"d":"M42.367 26.211a1 1 0 01.633.93v5.32a1 1 0 01-.633.93v-7.18zM5 27.142a1 1 0 01.633-.93v7.179A1 1 0 015 32.46v-5.318z","stroke":"#000C1F","stroke-width":"1.317"}}),_c('circle',{attrs:{"cx":"16.389","cy":"29.472","r":"2.633","fill":"#3DAFB8"}}),_c('circle',{attrs:{"cx":"31.611","cy":"29.471","r":"2.633","fill":"#3DAFB8"}}),_c('rect',{attrs:{"x":"23.342","y":"8.737","width":"1.317","height":"8.31","rx":".658","stroke":"#000C1F","stroke-width":"1.317"}}),_c('circle',{attrs:{"cx":"24","cy":"7.832","r":"2.633","fill":"#000C1F"}})])
          )
        }
      }
    